import PropTypes from "prop-types";
import React, { useRef, useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";

//redux
import { useSelector, useDispatch, } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/_Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, loginParticipantUser } from "store/actions";

// import images
import schorLogo1 from "assets/images/schor-logo.png"
import schorFrenchLogo from "assets/images/french-logo.png"

//Import config
import ReCAPTCHA from "react-google-recaptcha";
import toastr from "toastr";
import LanguageDropdownWithoutLogin from "components/CommonForBoth/TopbarDropdown/LanguageDropdownWithoutLogin";
import { withTranslation } from "react-i18next";
import { lowerCase } from "lodash";
import i18n from '../../../i18n';



const sitekey = process.env.REACT_APP_ENV == "development" ? process.env.REACT_APP_CAPTCHA_KEY_DEV : process.env.REACT_APP_CAPTCHA_KEY_PROD
console.log("PARTICIPANT LOGIN SITEKEY:-", sitekey)

const Login = props => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location

  const recaptchaRef = useRef(null);
  const [capVal, SetCapVal] = useState(null);
  const [language, setLanguage] = useState("en");
  const [key, setKey] = useState(Date.now());

  //meta title
  document.title = "Login | Institute on Governance - Participant & Dashboard";

  const dispatch = useDispatch();
  const { loading } = useSelector((s) => s.ParticipantLogin)

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      username: '',
      password: ''
    },
    validationSchema: Yup.object({
      username: Yup.string().required(props.t("Please Enter Your Username")),
      password: Yup.string().required(props.t("Please Enter Your Password")),

    }),
    onSubmit: (values) => {

      values.username = values.username.trim();
      values.password = values.password.trim();
      
      if (capVal) {
        values = {
          ...values,
          recaptchaToken: capVal || null
        }
      }
      dispatch(loginParticipantUser(values, "participant", (res) => {
        if (res.status === "success") {
          console.log("res?.message", res?.message)
          localStorage.setItem("number", 40)
          window.location.href = '/dashboard'
          toastr.success(res?.message)

        } else {
          toastr.error(res?.message)
        }
      }))
    }

  });

  const { error } = useSelector(state => ({
    error: state.ParticipantLogin.error,
  }));

  const onChangeCaptcha = (value) => {
    SetCapVal(value)
  }



  const handleSelectedLanguage = (lang) => {

    if (lang === "en") {
      setLanguage("en");
      setKey(Date.now());
      // console.log("Selected language: English");
    }

    if (lang === "es") {
      setLanguage("es");
      setKey(Date.now());
      // console.log("Selected language: Spanish");
    }

    if (lang === "fr") {
      setLanguage("fr");
      setKey(Date.now());
      // console.log("Selected language: French");
    }

    if (lang === "iu") {
      setLanguage("en");
      setKey(Date.now());
      // console.log("Selected language: Inuktitut");
    }

    if (lang === "ar") {
      setLanguage("ar");
      setKey(Date.now());
      // console.log("Selected language: Inuktitut");
    }

    if (lang === "ku") {
      setLanguage("en");
      setKey(Date.now());
      // console.log("Selected language: Inuktitut");
    }

    if (lang === "de") {
      setLanguage("de");
      setKey(Date.now());
      // console.log("Selected language: Inuktitut");
    }
  }
  useEffect(() => {


    if (!localStorage.getItem("i18nextLng") &&
      !localStorage.getItem("language_id") &&
      !localStorage.getItem("I18N_LANGUAGE")) {


      setTimeout(() => {
        localStorage.setItem("i18nextLng", 'EN');
        localStorage.setItem("language_id", '1');
        localStorage.setItem("I18N_LANGUAGE", 'EN');
        i18n.changeLanguage('EN');
      }, 1);
    }

    // setTimeout(() => {
    //   localStorage.setItem("i18nextLng", 'EN');
    //   localStorage.setItem("language_id", '1');
    //   localStorage.setItem("I18N_LANGUAGE", 'EN');
    //   i18n.changeLanguage('EN');
    // }, 1);


    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  }, [language]);

  return (
    <React.Fragment>

      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">

            <Col md={8} lg={6} xl={5}>
              <div className="main-form-wrapper" style={{ "border": "1px solid #ccc", "padding": "40px 30px 30px", "borderRadius": "20px", 'maxWidth': "800px", "margin": "auto", "background": " #fff" }}>
                <div className="home-btn d-none d-sm-block">
                  <div className="d-flex">
                    <div className="d-flex justify-content-end">
                      <LanguageDropdownWithoutLogin selectedLanguage={handleSelectedLanguage} />
                    </div>
                    <div style={{ marginTop: '20px', marginLeft: '5px' }}>
                      <Link to="/" className="text-dark">
                        <i className="bx bx-home h2" />
                      </Link>
                    </div>
                  </div>
                </div>
                <Card className="overflow-hidden">

                  <div>
                    <div className="avatar-md profile-user-wid mb-4 d-flex justify-content-center">
                      <span className="avatar-title rounded-circle bg-light">
                        <Link to="/" className="logo-light-element d-block">
                          <img
                            src={language == "fr" ? schorFrenchLogo : schorLogo1}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </Link>

                      </span>
                    </div>
                  </div>
                  <Row className="align-items-end text-center justify-content-center">
                    <Col xs={9}>
                      <div className="text-primary p-4 pb-0 heading-form">
                        <h4 className="text-black">{props.t("Participant Panel")}</h4>
                        <p className="text-black">{props.t("Sign in to continue")}.</p>
                      </div>
                    </Col>
                  </Row>
                  <CardBody className="pt-0 pb-2">
                    <div className="p-2">
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >

                        <div className="mb-3">
                          <Label className="form-label m-0">{props.t("Username")}:</Label>
                          <Input
                            name="username"
                            className="form-control"
                            placeholder={props.t("Enter username")}
                            type="text"
                            // onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            onChange={(e) => {
                              const val = e.target.value.replace(/\s+/g, ""); // remove all spaces
                              validation.setFieldValue("username", val);
                            }}
                            value={validation.values.username || ""}
                            invalid={
                              validation.touched.username && validation.errors.username ? true : false
                            }
                          />
                          {validation.touched.username && validation.errors.username ? (
                            <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label m-0">{props.t("Password")}:</Label>
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type="password"
                            placeholder={props.t("Enter Password")}
                            // onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            onChange={(e) => {
                              const val = e.target.value.replace(/\s+/g, ""); // remove all spaces
                              validation.setFieldValue("password", val);
                            }}
                            invalid={
                              validation.touched.password && validation.errors.password ? true : false
                            }
                          />
                          {validation.touched.password && validation.errors.password ? (
                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          {/* <Label className="form-label m-0">{props.t("Verification")}:</Label> */}
                          <div style={{ height: '70px' }}>
                            <ReCAPTCHA
                              ref={recaptchaRef}
                              hl={language}
                              key={key}
                              sitekey={sitekey}
                              onChange={(val) => onChangeCaptcha(val)}
                            />
                          </div>
                        </div>
                        <div className="btn-login-admin mt-3 d-grid batches-add-modal-btn">

                          {
                            loading ?
                              <button
                                type="button"
                                className="btn btn-dark"
                                disabled
                              >
                                <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                              </button>
                              :
                              <button
                                // disabled={!capVal}
                                className="btn btn-primary btn-block green-btn"
                                type="submit"
                              >
                                {props.t("Log In")}
                              </button>
                          }
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </div>
              <div className="mt-5 text-center">
                <p className="m-0 text-center">
                  © {new Date().getFullYear()} Institute on Governance. {props.t("Crafted with")}{" "}
                  <i className="mdi mdi-heart text-danger" /> {props.t("by Suffescom")}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

    </React.Fragment>
  );
};

Login.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
};

export default withTranslation()(Login);
